<template>
  <div class="slug">
    <div class="top-div">
      <p>{{ type }}</p>
      <p>{{ text }}</p>
      <div class="button" @click="navigateTo('/')">
        {{ t("common.back_to_home") }}
      </div>
      <!-- 背景 -->
      <div class="bg">{{ type }}</div>
    </div>
    <img class="bottom-img" src="~/assets/images/error.png" alt="" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  type: {
    type: String,
    default: "404",
  },
  text: {
    type: String,
    default: "",
  },
});
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.slug {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  .top-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    padding-top: 170px;
    p:nth-child(1) {
      color: rgba(0, 0, 0, 0.85);
      font-family: "MiSans VF";
      font-size: 96px;
      font-weight: 305;
    }
    p:nth-child(2) {
      color: rgba(0, 0, 0, 0.7);
      font-family: "HarmonyOS Sans";
      font-size: 48px;
      font-weight: 300;
      margin-top: 8px;
    }
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      width: 203px;
      height: 56px;
      flex-shrink: 0;
      border-radius: 12px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      background: rgba(255, 255, 255, 0.25);
      color: rgba(0, 0, 0, 0.95);
      font-size: 20px;
      line-height: 24px;
      margin-top: 52px;
    }
    .bg {
      position: absolute;
      color: #f2f2f2;
      font-family: "MiSans VF";
      font-size: 500px;
      font-weight: 700;
      line-height: 400px;
      z-index: -1;
      top: 85px;
    }
  }
  .bottom-img {
    width: 1200px;
    height: 359px;
    flex-shrink: 0;
    object-fit: cover;
  }
}
</style>
